import { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { styles } from "../../Utils/Common";
const FacilityDropdown = (props: any) => {
  const inputElementReactSelect = useRef(props?.name);
  const [selectedFacility, setSelectedFacility] = useState(null);
  const appliedFacility = useRef<any>(null);
  useEffect(() => {
    if (inputElementReactSelect.current && props._adminType != 2) {
      if (props.errorFocussedInput === inputElementReactSelect.current.id) {
        inputElementReactSelect.current.focus();
      }
    }
  }, [props.errorFocussedInput]);
  // Inputs are refetched and replaced during load, and each replacement brings
  // back an empty Facility field. Re-apply whenever it is empty so the pre-fill
  // is not lost, which silently broke Save for facility users (_adminType == 2)
  // whose dropdown and error message are both hidden.
  useEffect(() => {
    const currentValue = `${props.items?.defaultValue ?? ""}`;

    if (currentValue) {
      const applied = props.facilityList?.find(
        (facility: any) => `${facility?.value}` === currentValue
      );
      if (applied) {
        appliedFacility.current = applied;
      }
      return;
    }

    const facilityToApply =
      appliedFacility.current ??
      (props.facilityList?.length === 1 ? props.facilityList[0] : null);

    if (!facilityToApply) return;

    appliedFacility.current = facilityToApply;
    setSelectedFacility(facilityToApply);
    // Pre-fill, not a user change: keeps the saved physician signature.
    props.onFacilitySelect(facilityToApply, false);
  }, [props.items?.defaultValue, props.facilityList]);

  useEffect(() => {
    // Mirror only a real selection; the parent starts this prop out empty.
    if (!props.selectedFacilities) return;
    setSelectedFacility(props.selectedFacilities);
  }, [props.selectedFacilities]);
  const handleFacilitySelect = (selectedOption: any) => {
    props.items.enableRule = "";
    setSelectedFacility(selectedOption);
    props.onFacilitySelect(selectedOption, true);
  };
  const divElement = useRef<HTMLDivElement | null>(null); // Initialize ref for div
  useEffect(() => {
    // Scroll to the div if props.error is present
    if (props.error && divElement.current) {
      divElement.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    props.setErrorFocussedInput && props.setErrorFocussedInput();
  }, [props?.errorFocussedInput]);
  return (
    <div id={props.name} tabIndex={-1}>
      {props._adminType != 2 && (
        <Select
          menuPortalTarget={document.body}
          ref={inputElementReactSelect}
          options={props.facilityList}
          inputId={props.name}
          theme={(theme) => styles(theme)}
          value={selectedFacility}
          onChange={handleFacilitySelect}
          isSearchable={true}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              borderColor: "var(--kt-input-border-color)",
              color: "var(--kt-input-border-color)",
            }),
          }}
        />
      )}
    </div>
  );
};

export default FacilityDropdown;
